export let invoicesStatus = [
    {id: 1, title: 'ارسال شده'},
    {id: 2, title: 'تاریخ سررسید گذشته'},
    {id: 3, title: 'دریافت شده'},
    {id: 5, title: 'پرداخت ناقص'},
]

export let invoicesData = [
    {
        id: 1,
        name: 'املیا کلارک',
        img: '/images/avatars/1.png',
        company: 'توسعه دهنده وب',
        debt: 0,
        total: 35794500,
        status: 'ارسال شده',
        issueDate: '1403/05/15',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 2, title: 'قالب ABC', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 2,
        name: 'جان اسنو',
        img: '/images/avatars/14.png',
        company: 'تایپیست',
        debt: 0,
        total: 78924710,
        status: 'دریافت شده',
        issueDate: '1402/09/09',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 2, title: 'قالب ABC', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 3, title: 'توسعه برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 3,
        name: 'پیتر پارکر',
        img: '/images/avatars/12.png',
        company: 'توسعه دهنده وب',
        debt: 5884290,
        total: 45824910,
        status: 'پرداخت ناقص',
        issueDate: '1402/07/14',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 4,
        name: 'نیمار جونیور',
        img: '/images/avatars/10.png',
        company: 'توسعه دهنده بک اند',
        debt: 0,
        total: 12853950,
        status: 'ارسال شده',
        issueDate: '1403/10/22',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 5,
        name: 'لوییس سوارز',
        img: '/images/avatars/9.png',
        company: 'توسعه دهنده فرانت اند',
        debt: 0,
        total: 25380950,
        status: 'دریافت شده',
        issueDate: '1400/01/02',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 2, title: 'قالب ABC', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 6,
        name: 'جوردی آلبا',
        img: '/images/avatars/6.png',
        company: 'توسعه دهنده وب',
        debt: 3582560,
        total: 73811930,
        status: 'تاریخ سررسید گذشته',
        issueDate: '1402/10/25',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 7,
        name: 'مارتین ادگارد',
        img: '/images/avatars/5.png',
        company: 'طراح محصول',
        debt: 0,
        total: 14785350,
        status: 'پرداخت ناقص',
        issueDate: '1401/08/01',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 2, title: 'قالب ABC', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 8,
        name: 'فران تورس',
        img: '/images/avatars/4.png',
        company: 'دیزاینر',
        debt: 0,
        total: 16870050,
        status: 'دریافت شده',
        issueDate: '1400/11/12',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 2, title: 'قالب ABC', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 3, title: 'توسعه برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 9,
        name: 'ژاوی هرناندز',
        img: '/images/avatars/2.png',
        company: 'گرافیست',
        debt: 7824900,
        total: 77362980,
        status: 'ارسال شده',
        issueDate: '1403/08/06',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 2, title: 'قالب ABC', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
    {
        id: 10,
        name: 'لوکا مودریچ',
        img: '/images/avatars/1.png',
        company: 'توسعه دهنده بک اند',
        debt: 0,
        total: 41189460,
        status: 'تاریخ سررسید گذشته',
        issueDate: '1402/10/20',
        msg: 'از کسب و کار شما متشکریم',
        tax: 3500000,
        offer: 2500000,
        notice: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله',
        items: [
            {id: 1, title: 'طراحی برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 2, title: 'قالب ABC', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
            {id: 3, title: 'توسعه برنامه', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با', count: 1, price: 24000, total: 350000},
        ]
    },
]